import determineFieldType from '../common/determineFieldType';
import { requestGet as wsRequestGet, requestPost as wsRequestPost, requestDelete as wsRequestDelete } from './_wsApiFetchData';

export async function getArea(id, language, timeZone, cancelToken) {
    return await wsRequestGet(`/admin/areas/${id}`, language, timeZone, null, cancelToken);
}

export async function lookupByNameOrId(key, language, timeZone, cancelToken) {
    if (!key) {
        return [];
    }

    const fieldName = await determineFieldType(key);

    const supportedFields = ['Id', 'Name'];

    if (supportedFields.indexOf(fieldName) < 0) {
        return [];
    }

    if (fieldName === 'Id') {
        const area = await getArea(key, language, timeZone, cancelToken);

        return [{
            label: area.name || area.Name,
            value: area.areaId || area.AreaId
        }];
    } if (fieldName === 'Name') {
        const option = {
            Name: key
        }
        const results = await searchArea(option, language, timeZone, cancelToken);
        return results.areas.map((area) => ({
            label: area.name || area.Name,
            value: area.areaId || area.AreaId
        }));
    }
}

export async function searchArea(options, language, timeZone, cancelToken) {
    return await wsRequestGet('/admin/areas/search', language, timeZone, options, cancelToken);
}

export async function searchAreas({ filters }, language, timeZone, cancelToken) {
    return await wsRequestGet('/admin/areas/search', language, timeZone, filters, cancelToken);
}

export async function createArea(data, language, timeZone, cancelToken) {
    return await wsRequestPost('/admin/areas', language, timeZone, data, null, cancelToken);
}

export async function updateArea(id, data, language, timeZone, cancelToken) {
    return await wsRequestPost(`/admin/areas/${id}`, language, timeZone, data, null, cancelToken);
}

export async function deleteArea(id, language, timeZone, cancelToken) {
    return await wsRequestDelete(`/admin/areas/${id}`, language, timeZone, null, null, cancelToken);
}

